var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules",style:({ paddingBottom: _vm.$store.state.paddingBottom + 'px' })},[_c('NavigationBar',{scopedSlots:_vm._u([{key:"center",fn:function(){return [_vm._v(" Tippabgabe ")]},proxy:true}])}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }